import { ShippingRateGroupDto, VariationFe } from "@intelligems/ig-types";

export type ShippingRateGroupReducerAction =
  | {
      type: "updateFlatRate";
      payload: {
        shippingRateGroupIndex: number;
        testGroupIndex: number;
        shippingRateIndex: number;
        valueToChange:
          | "name"
          | "amount"
          | "max"
          | "min"
          | "description"
          | "rateCode";
        newValue: string;
      };
    }
  | {
      type: "updateTierRate";
      payload: {
        shippingRateGroupIndex: number;
        testGroupIndex: number;
        shippingRateIndex: number;
        valueToChange:
          | "name"
          | "amount"
          | "max"
          | "min"
          | "description"
          | "rateCode";
        newValue: any;
      };
    }
  | {
      type: "clearShippingRateGroup";
      initialState: ShippingRateGroupDto[];
    };

export function ShippingRateGroupReducer(
  draft: VariationFe,
  action: ShippingRateGroupReducerAction
) {
  switch (action.type) {
    case "updateFlatRate":
      draft.shippingRateGroups![action.payload.shippingRateGroupIndex].rates[
        action.payload.shippingRateIndex
      ][action.payload.valueToChange] = action.payload.newValue;
      return draft;
    case "updateTierRate":
      draft.shippingRateGroups![action.payload.shippingRateGroupIndex].rates[
        action.payload.shippingRateIndex
      ].condition![action.payload.valueToChange as "max" | "min"] =
        action.payload.newValue;
      return draft;
    case "clearShippingRateGroup":
      draft.shippingRateGroups = action.initialState;
      return draft;
  }
}
